const batch = user => {
  const unauthorizedUsers = ["monica.alves"];
  const isUnauthorizedUser = unauthorizedUsers.includes(user);
  return isUnauthorizedUser;
};

export const unauthorizedUsers = {
  batch
};
